import type { InspectionReport, InspectionReportBase } from "../../types";
import { createBaseService } from "./baseService";

const base = createBaseService<InspectionReport, InspectionReportBase>({
  tableName: "inspection_reports",
  viewName: "inspection_reports_enriched",
  computedColumns: ["inspectionTitle"],
  searchColumns: ["inspection_title"],
});

export class InspectionReportService {
  static getAll = base.getAll;
  static get = base.get;
  static create = base.create;
  static update = base.update;
  static delete = base.delete;
}
